module.exports = __webpack_public_path__ + "img/sym2.5ed5ea6a.png";